import { ObjetKStatusCode } from '@siclop/kstone-vue'
import type { WorkScheduleDay } from './WorkScheduleDay'

export class WorkScheduleTemplate extends ObjetKStatusCode {
  description: string = ''
  weeklyHours: number = 0
  isDefault: boolean = false
  days: WorkScheduleDay[] = []

  constructor(data?: Partial<WorkScheduleTemplate>) {
    super(data)
    if (data) {
      this.description = data.description ?? ''
      this.weeklyHours = data.weeklyHours ?? 0
      this.isDefault = data.isDefault ?? false
      this.days = data.days ?? []
    }
  }
}
